<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('trackingClient.sidebar.shortTitle')"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: $t('trackingClient.sidebar.opened'),
            path: '/trackingClient/opened',
            icon: 'tim-icons icon-delivery-fast',
          }"
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: $t('trackingClient.sidebar.finished'),
            path: '/trackingClient/finished',
            icon: 'tim-icons icon-app',
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <tracking-client-layout-navbar></tracking-client-layout-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
//import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import ContentFooter from "@/pages/Layout/ContentFooter.vue";
import SidebarFixedToggleButton from "@/pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import TrackingClientLayoutNavbar from "@/pagesRms/trackingClient/TrackingClientLayoutNavbar.vue";

export default {
  name: "TrackingClientLayout",
  components: {
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
    TrackingClientLayoutNavbar,
  },
  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
    };
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    isUserFormCreator() {
      return this.$store.getters.isChecklistFormCreator;
    },
    isUserPendenciesViewer() {
      return this.$store.getters.isChecklistPendenciesView;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        //initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemSchedules) {
      if (this.$refs.sidebarItemSchedules.collapsed) {
        this.$refs.sidebarItemSchedules.collapseMenu();
      }
    }
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
